import { combineReducers, Reducer } from 'redux';
import timeline from './ducks/timeline';

const createRootReducer = (): Reducer =>
  combineReducers({
    timeline,
  });

export { createRootReducer };
